webpackJsonp([0,9],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	var _history = __webpack_require__(6);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _redux = __webpack_require__(196);
	
	var _reactRedux = __webpack_require__(209);
	
	var _reduxThunk = __webpack_require__(217);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouter = __webpack_require__(218);
	
	var _reactRouterRedux = __webpack_require__(256);
	
	var _reactGa = __webpack_require__(261);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _configureStore = __webpack_require__(270);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _routes = __webpack_require__(292);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _network = __webpack_require__(309);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _config = __webpack_require__(280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ga.initialize(GA_TRACKING_CODE);
	
	var analytics = function analytics(store) {
	  return function (next) {
	    return function (action) {
	      if (action.noGA) {
	        return next(action);
	      }
	      if (action.type.length > 0 && action.type[0] !== '@') {
	        _reactGa2.default.event({
	          category: action.type.split('_')[0],
	          action: action.type
	        });
	      }
	      return next(action);
	    };
	  };
	};
	
	var appHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
	  queryKey: false
	});
	var historyMiddleware = (0, _reactRouterRedux.routerMiddleware)(appHistory);
	
	// const middleWares = composeMiddleware(thunk, promise, batchedUpdatesMiddleware);
	
	var store = (0, _redux.createStore)(
	// enableBatching(reducers),
	_configureStore2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default, historyMiddleware, analytics));
	
	window.store = store;
	
	setInterval(function () {
	  _network2.default.clear();
	}, 15 * 1000 * 60);
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(appHistory, store);
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_routes2.default, { history: history })
	), document.getElementById('app'));

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./index.scss", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, "body{font-size:16px}.f-a,a{text-decoration:none;color:#007ee5;cursor:pointer}.row{max-width:100%}.row.bottom-space{padding-bottom:25px}.row.add-bottom-padding{padding-bottom:60px}.container{padding:10px}.container.no-login{position:fixed;width:400px;top:30px;left:35%;text-align:center}.keyword-link{display:inline-block;padding:1px 4px;margin-left:2px;margin-bottom:8px;font-size:.8em;background:#007ee5;color:#fff;padding:3px 10px;margin-right:8px;border-radius:3px}.main-navigation{margin-bottom:10px;margin-right:12px;overflow:auto}.keyword-list-container{margin:4px 0;text-transform:capitalize;border-radius:3px;border:1px solid rgba(37,40,43,.1)}.keyword-list-container .keyword-input{border:none;margin:0}.keyword-list-container .c-token{margin-left:6px;margin-right:0}.keyword-list-container.is-invalid{border-color:rgba(232,33,16,.5)}.hint-text{text-transform:inherit;font-size:1em;font-weight:700;color:#444;margin-bottom:7px}.hint-text.tiny-text{color:#0071ce;font-size:.8em;font-weight:400}.keyword-suggestion-container{padding:10px;margin-bottom:10px;background:#f1f1f1;position:relative;left:-5px;border-radius:0;width:103%;border-top:1px solid #ddd;border-bottom:1px solid #ddd}.keyword-suggestion-container .c-token{cursor:pointer;font-size:.8em;text-transform:capitalize;margin:4px 4px 4px 0;background-color:#36c;color:#fff;padding:5px 8px 7px;margin-bottom:10px}.arrow{width:30px;height:30px;display:block;position:absolute;z-index:9999;background:#f1f1f1;transform:rotate(45deg);margin-top:-5px;right:33px}.image-keywords{line-height:1.3em}.link-active{color:#545454}.capitalize{text-transform:capitalize}h1{margin:1.5em 0}.right{float:right}.align-right{text-align:right}.left{float:left}.c-card{display:block}.text-info{color:#007ee5;margin:4px 0;font-size:.9em;line-height:1.3em}.c-btn:not(button):not([type=submit]){outline:none!important}.list-item-anim-enter{opacity:.01}.list-item-anim-enter.list-item-anim-enter-active{opacity:1;transition:opacity .5s ease-in}.list-item-anim-leave{opacity:1}.list-item-anim-leave.list-item-anim-leave-active{opacity:.01;transition:opacity .3s ease-in}.no-padding{padding:0}", ""]);
	
	// exports


/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * React Google Analytics Module
	 *
	 * @package react-ga
	 * @author  Adam Lofting <adam@mozillafoundation.org>
	 *          Atul Varma <atul@mozillafoundation.org>
	 */
	
	/**
	 * Utilities
	 */
	var format = __webpack_require__(262);
	var removeLeadingSlash = __webpack_require__(267);
	var trim = __webpack_require__(265);
	
	var warn = __webpack_require__(266);
	var log = __webpack_require__(268);
	
	var _debug = false;
	var _titleCase = true;
	
	var _format = function (s) {
	  return format(s, _titleCase);
	};
	
	var ReactGA = {
	  initialize: function (gaTrackingID, options) {
	    if (!gaTrackingID) {
	      warn('gaTrackingID is required in initialize()');
	      return;
	    }
	
	    if (options) {
	      if (options.debug && options.debug === true) {
	        _debug = true;
	      }
	
	      if (options.titleCase === false) {
	        _titleCase = false;
	      }
	    }
	
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	    // jscs:disable
	    (function (i, s, o, g, r, a, m) {
	      i['GoogleAnalyticsObject'] = r;
	      i[r] = i[r] || function () {
	        (i[r].q = i[r].q || []).push(arguments);
	      }, i[r].l = 1 * new Date();
	      a = s.createElement(o),
	          m = s.getElementsByTagName(o)[0];
	      a.async = 1;
	      a.src = g;
	      m.parentNode.insertBefore(a, m);
	    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	    // jscs:enable
	
	    if (options && options.gaOptions) {
	      ga('create', gaTrackingID, options.gaOptions);
	    } else {
	      ga('create', gaTrackingID, 'auto');
	    }
	
	  },
	
	  /**
	   * set:
	   * GA tracker set method
	   * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	   */
	  set: function (fieldsObject) {
	    if (typeof ga === 'function') {
	      if (!fieldsObject) {
	        warn('`fieldsObject` is required in .set()');
	        return;
	      }
	
	      if (typeof fieldsObject !== 'object') {
	        warn('Expected `fieldsObject` arg to be an Object');
	        return;
	      }
	
	      if (Object.keys(fieldsObject).length === 0) {
	        warn('empty `fieldsObject` given to .set()');
	      }
	
	      ga('set', fieldsObject);
	
	      if (_debug) {
	        log('called ga(\'set\', fieldsObject);');
	        log('with fieldsObject: ' + JSON.stringify(fieldsObject));
	      }
	    }
	  },
	
	  /**
	   * send:
	   * Clone of the low level `ga.send` method
	   * WARNING: No validations will be applied to this
	   * @param  {Object} fieldObject - field object for tracking different analytics
	   */
	  send: function (fieldObject) {
	    if (typeof ga === 'function') {
	      ga('send', fieldObject);
	
	      if (_debug) {
	        log('called ga(\'send\', fieldObject);');
	        log('with fieldObject: ' + JSON.stringify(fieldObject));
	      }
	    }
	  },
	
	  /**
	   * pageview:
	   * Basic GA pageview tracking
	   * @param  {String} path - the current page page e.g. '/about'
	   */
	  pageview: function (path) {
	    if (!path) {
	      warn('path is required in .pageview()');
	      return;
	    }
	
	    path = trim(path);
	    if (path === '') {
	      warn('path cannot be an empty string in .pageview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * modalview:
	   * a proxy to basic GA pageview tracking to consistently track
	   * modal views that are an equivalent UX to a traditional pageview
	   * @param  {String} modalName e.g. 'add-or-edit-club'
	   */
	  modalview: function (modalName) {
	    if (!modalName) {
	      warn('modalName is required in .modalview(modalName)');
	      return;
	    }
	
	    modalName = trim(modalName);
	    modalName = removeLeadingSlash(modalName);
	
	    if (modalName === '') {
	      warn('modalName cannot be an empty string or a single / in .modalview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      modalName = trim(modalName);
	      var path = '/modal/' + modalName;
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * timing:
	   * GA timing
	   * @param args.category {String} required
	   * @param args.variable {String} required
	   * @param args.value  {Int}  required
	   * @param args.label  {String} required
	   */
	  timing: function (args) {
	    if (typeof ga === 'function') {
	      if (!args || !args.category || !args.variable
	          || !args.value || typeof args.value !== 'number') {
	        warn('args.category, args.variable ' +
	              'AND args.value are required in timing() ' +
	              'AND args.value has to be a number');
	        return;
	      }
	
	      //Required Fields
	      var fieldObject = {
	        hitType: 'timing',
	        timingCategory: _format(args.category),
	        timingVar: _format(args.variable),
	        timingValue: args.value
	      };
	
	      if (args.label) {
	        fieldObject.timingLabel = _format(args.label);
	      }
	
	      this.send(fieldObject);
	    }
	  },
	
	  /**
	   * event:
	   * GA event tracking
	   * @param args.category {String} required
	   * @param args.action {String} required
	   * @param args.label {String} optional
	   * @param args.value {Int} optional
	   * @param args.nonInteraction {boolean} optional
	   */
	  event: function (args) {
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.category || !args.action) {
	        warn('args.category AND args.action are required in event()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'event',
	        eventCategory: _format(args.category),
	        eventAction: _format(args.action)
	      };
	
	      // Optional Fields
	      if (args.label) {
	        fieldObject.eventLabel = _format(args.label);
	      }
	
	      if (args.value) {
	        if (typeof args.value !== 'number') {
	          warn('Expected `args.value` arg to be a Number.');
	        } else {
	          fieldObject.eventValue = args.value;
	        }
	      }
	
	      if (args.nonInteraction) {
	        if (typeof args.nonInteraction !== 'boolean') {
	          warn('`args.nonInteraction` must be a boolean.');
	        } else {
	          fieldObject.nonInteraction = args.nonInteraction;
	        }
	      }
	
	      // Send to GA
	      this.send(fieldObject);
	    }
	  },
	
	  /**
	   * exception:
	   * GA exception tracking
	   * @param args.description {String} optional
	   * @param args.fatal {boolean} optional
	   */
	  exception: function (args) {
	    if (typeof ga === 'function') {
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'exception'
	      };
	
	      // Optional Fields
	      if (args.description) {
	        fieldObject.exDescription = _format(args.description);
	      }
	
	      if (typeof args.fatal !== 'undefined') {
	        if (typeof args.fatal !== 'boolean') {
	          warn('`args.fatal` must be a boolean.');
	        } else {
	          fieldObject.exFatal = args.fatal;
	        }
	      }
	
	      // Send to GA
	      this.send(fieldObject);
	    }
	  },
	
	  plugin: {
	    /**
	     * require:
	     * GA requires a plugin
	     * @param name {String} e.g. 'ecommerce' or 'myplugin'
	     * @param options {Object} optional e.g {path: '/log', debug: true}
	     */
	    require: function (name, options) {
	      if (typeof ga === 'function') {
	
	        // Required Fields
	        if (!name) {
	          warn('`name` is required in .require()');
	          return;
	        }
	
	        name = trim(name);
	        if (name === '') {
	          warn('`name` cannot be an empty string in .require()');
	          return;
	        }
	
	        // Optional Fields
	        if (options) {
	          if (typeof options !== 'object') {
	            warn('Expected `options` arg to be an Object');
	            return;
	          }
	
	          if (Object.keys(options).length === 0) {
	            warn('Empty `options` given to .require()');
	          }
	
	          ga('require', name, options);
	
	          if (_debug) {
	            log('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options) + ');');
	          }
	
	          return;
	        } else {
	          ga('require', name);
	
	          if (_debug) {
	            log('called ga(\'require\', \'' + name + '\');');
	          }
	
	          return;
	        }
	      }
	    },
	
	    /**
	     * execute:
	     * GA execute action for plugin
	     * Takes variable number of arguments
	     * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	     * @param action {String} e.g. 'addItem' or 'myCustomAction'
	     * @param actionType {String} optional e.g. 'detail'
	     * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	     */
	    execute: function () {
	      var args = Array.prototype.slice.call(arguments);
	
	      var pluginName = args[0];
	      var action = args[1];
	      var payload;
	      var actionType;
	
	      if (args.length === 3) {
	        payload = args[2];
	      } else {
	        actionType = args[2];
	        payload = args[3];
	      }
	
	      if (typeof ga === 'function') {
	        if (typeof pluginName !== 'string') {
	          warn('Expected `pluginName` arg to be a String.');
	        } else if (typeof action !== 'string') {
	          warn('Expected `action` arg to be a String.');
	        } else {
	          var command = pluginName + ':' + action;
	          payload = payload || null;
	          if (actionType && payload) {
	            ga(command, actionType, payload);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	              log('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	            }
	          } else if (payload) {
	            ga(command, payload);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	              log('with payload: ' + JSON.stringify(payload));
	            }
	          } else {
	            ga(command);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	            }
	
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * outboundLink:
	   * GA outboundLink tracking
	   * @param args.label {String} e.g. url, or 'Create an Account'
	   * @param {function} hitCallback - Called after processing a hit.
	   */
	  outboundLink: function (args, hitCallback) {
	    if (typeof hitCallback !== 'function') {
	      warn('hitCallback function is required');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.label) {
	        warn('args.label is required in outboundLink()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        hitType: 'event',
	        eventCategory: 'Outbound',
	        eventAction: 'Click',
	        eventLabel: _format(args.label)
	      };
	
	      var safetyCallbackCalled = false;
	      var safetyCallback = function () {
	
	        // This prevents a delayed response from GA
	        // causing hitCallback from being fired twice
	        safetyCallbackCalled = true;
	
	        hitCallback();
	      };
	
	      // Using a timeout to ensure the execution of critical application code
	      // in the case when the GA server might be down
	      // or an ad blocker prevents sending the data
	
	      // register safety net timeout:
	      var t = setTimeout(safetyCallback, 250);
	
	      var clearableCallbackForGA = function () {
	        clearTimeout(t);
	        if (!safetyCallbackCalled) {
	          hitCallback();
	        }
	      };
	
	      fieldObject.hitCallback = clearableCallbackForGA;
	
	      // Send to GA
	      this.send(fieldObject);
	    } else {
	      // if ga is not defined, return the callback so the application
	      // continues to work as expected
	      setTimeout(hitCallback, 0);
	    }
	  }
	};
	
	var OutboundLink = __webpack_require__(269);
	OutboundLink.origTrackLink = OutboundLink.trackLink;
	OutboundLink.trackLink = ReactGA.outboundLink.bind(ReactGA);
	ReactGA.OutboundLink = OutboundLink;
	
	module.exports = ReactGA;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var mightBeEmail = __webpack_require__(263);
	var toTitleCase = __webpack_require__(264);
	var warn = __webpack_require__(266);
	
	var _redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if (mightBeEmail(s)) {
	    warn('This arg looks like an email address, redacting.');
	    return _redacted;
	  }
	
	  if (titleCase) {
	    return toTitleCase(s);
	  }
	
	  return s;
	}
	
	module.exports = format;


/***/ },
/* 263 */
/***/ function(module, exports) {

	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/).test(s);
	}
	
	module.exports = mightBeEmail;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	
	var trim = __webpack_require__(265);
	
	function toTitleCase(s) {
	  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	  s = trim(s);
	
	  return s.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 &&
	        index + match.length !== title.length &&
	        match.search(smallWords) > -1 &&
	        title.charAt(index - 2) !== ':' &&
	        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
	        title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	module.exports = toTitleCase;


/***/ },
/* 265 */
/***/ function(module, exports) {

	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	module.exports = trim;


/***/ },
/* 266 */
/***/ function(module, exports) {

	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	module.exports = warn;


/***/ },
/* 267 */
/***/ function(module, exports) {

	function removeLeadingSlash(s) {
	  if (s.substring(0, 1) === '/') {
	    s = s.substring(1);
	  }
	
	  return s;
	}
	
	module.exports = removeLeadingSlash;


/***/ },
/* 268 */
/***/ function(module, exports) {

	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	module.exports = log;


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(33);
	var assign = __webpack_require__(35);
	
	var NEWTAB = '_blank';
	
	var OutboundLink = React.createClass({
	  displayName: 'OutboundLink',
	  propTypes: {
	    eventLabel: React.PropTypes.string.isRequired
	  },
	  statics: {
	    trackLink: function () {
	      console.warn('ga tracking not enabled');
	    }
	  },
	  handleClick: function (e) {
	    e.preventDefault();
	    var props = this.props;
	    var eventMeta = { label: props.eventLabel };
	    OutboundLink.trackLink(eventMeta, function () {
	      if (props.target === NEWTAB) {
	        window.open(props.to, NEWTAB);
	      } else {
	        window.location.href = props.to;
	      }
	    });
	
	    if (props.onClick) {
	      props.onClick(e);
	    }
	  },
	
	  render: function () {
	    var props = assign({}, this.props, {
	      href: this.props.to,
	      onClick: this.handleClick
	    });
	    return React.createElement('a', props);
	  }
	});
	
	module.exports = OutboundLink;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(196);
	
	var _reactRouterRedux = __webpack_require__(256);
	
	var _notification = __webpack_require__(271);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _fileselector = __webpack_require__(273);
	
	var _fileselector2 = _interopRequireDefault(_fileselector);
	
	var _imagegroup = __webpack_require__(275);
	
	var _imagegroup2 = _interopRequireDefault(_imagegroup);
	
	var _imagelist = __webpack_require__(276);
	
	var _imagelist2 = _interopRequireDefault(_imagelist);
	
	var _cropper = __webpack_require__(277);
	
	var _cropper2 = _interopRequireDefault(_cropper);
	
	var _searchlist = __webpack_require__(278);
	
	var _searchlist2 = _interopRequireDefault(_searchlist);
	
	var _user = __webpack_require__(279);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _image = __webpack_require__(291);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flockrApp = (0, _redux.combineReducers)({
	  notifications: _notification2.default,
	  files: _fileselector2.default,
	  imageList: _imagelist2.default,
	  cropper: _cropper2.default,
	  groups: _imagegroup2.default,
	  searchList: _searchlist2.default,
	  user: _user2.default,
	  image: _image2.default,
	  routing: _reactRouterRedux.routerReducer
	});
	
	exports.default = flockrApp;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getNewNotifId = undefined;
	
	var _actiontypes = __webpack_require__(272);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = [];
	
	var maxNotifications = 10;
	
	var notificationId = 1;
	
	var getNewNotifId = exports.getNewNotifId = function getNewNotifId() {
		return notificationId++;
	};
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actiontypes.NOTIFICATION_ADD:
				return [].concat(_toConsumableArray(state), [{
					id: action.id,
					data: action.data,
					type: action.notifType || 'primary'
				}]);
			case _actiontypes.NOTIFICATION_REMOVE:
				return state.filter(function (notif, index) {
					return notif.id !== action.id;
				});
			default:
				return state;
		}
	};

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_CHECK_LOGIN = exports.USER_CHECK_LOGIN = 'USER_CHECK_LOGIN';
	var USER_LOGGED_IN = exports.USER_LOGGED_IN = 'USER_LOGGED_IN';
	var USER_NOT_LOGGED_IN = exports.USER_NOT_LOGGED_IN = 'USER_NOT_LOGGED_IN';
	
	var NOTIFICATION_ADD = exports.NOTIFICATION_ADD = 'NOTIFICATION_ADD';
	var NOTIFICATION_REMOVE = exports.NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
	
	var FILES_DROPPED = exports.FILES_DROPPED = 'FILES_DROPPED';
	var FILES_CLEAR_ONE = exports.FILES_CLEAR_ONE = 'FILES_CLEAR_ONE';
	var FILES_CLEAR = exports.FILES_CLEAR = 'FILES_CLEAR';
	var FILES_ADD_KEYWORD = exports.FILES_ADD_KEYWORD = 'FILES_ADD_KEYWORD';
	var FILES_UPDATE_FIELD = exports.FILES_UPDATE_FIELD = 'FILES_UPDATE_FIELD';
	var FILES_REMOVE_KEYWORD = exports.FILES_REMOVE_KEYWORD = 'FILES_REMOVE_KEYWORD';
	var FILES_UPLOAD_STARTED = exports.FILES_UPLOAD_STARTED = 'FILES_UPLOAD_STARTED';
	var FILES_UPLOAD_CANCELLED = exports.FILES_UPLOAD_CANCELLED = 'FILES_UPLOAD_CANCELLED';
	var FILES_UPLOAD_COMPLETED = exports.FILES_UPLOAD_COMPLETED = 'FILES_UPLOAD_COMPLETED';
	var FILES_ENABLE_UPLOAD = exports.FILES_ENABLE_UPLOAD = 'FILES_ENABLE_UPLOAD';
	var FILES_DISABLE_UPLOAD = exports.FILES_DISABLE_UPLOAD = 'FILES_DISABLE_UPLOAD';
	var FILES_META_LOADED = exports.FILES_META_LOADED = 'FILES_META_LOADED';
	var FILES_META_ERROR = exports.FILES_META_ERROR = 'FILES_META_ERROR';
	var FILES_META_SHOW = exports.FILES_META_SHOW = 'FILES_META_SHOW';
	var FILES_META_HIDE = exports.FILES_META_HIDE = 'FILES_META_HIDE';
	var FILES_META_MERGE = exports.FILES_META_MERGE = 'FILES_META_MERGE';
	var FILES_SUGGESTION_HIDE = exports.FILES_SUGGESTION_HIDE = 'FILES_SUGGESTION_HIDE';
	var FILES_SUGGESTION_SHOW = exports.FILES_SUGGESTION_SHOW = 'FILES_SUGGESTION_SHOW';
	var FILES_ADD_IMAGE_SUGGESTIONS = exports.FILES_ADD_IMAGE_SUGGESTIONS = 'FILES_ADD_IMAGE_SUGGESTIONS';
	var FILES_FETCHING_IMAGE_SUGGESTIONS = exports.FILES_FETCHING_IMAGE_SUGGESTIONS = 'FILES_FETCHING_IMAGE_SUGGESTIONS';
	var FILES_FETCHED_IMAGE_SUGGESTIONS = exports.FILES_FETCHED_IMAGE_SUGGESTIONS = 'FILES_FETCHED_IMAGE_SUGGESTIONS';
	var FILES_FETCH_ERROR_IMAGE_SUGGESTIONS = exports.FILES_FETCH_ERROR_IMAGE_SUGGESTIONS = 'FILES_FETCH_ERROR_IMAGE_SUGGESTIONS';
	var FILES_SAVE_TEMP_PATH = exports.FILES_SAVE_TEMP_PATH = 'FILES_SAVE_TEMP_PATH';
	var FILES_FETCHED_IMAGE_SUGGESTIONS_WITH_EXIF = exports.FILES_FETCHED_IMAGE_SUGGESTIONS_WITH_EXIF = 'FILES_FETCHED_IMAGE_SUGGESTIONS_WITH_EXIF';
	var FILES_SHOW_IMAGE_SUGGESTION_MODAL = exports.FILES_SHOW_IMAGE_SUGGESTION_MODAL = 'FILES_SHOW_IMAGE_SUGGESTION_MODAL';
	var FILES_HIDE_IMAGE_SUGGESTION_MODAL = exports.FILES_HIDE_IMAGE_SUGGESTION_MODAL = 'FILES_HIDE_IMAGE_SUGGESTION_MODAL';
	
	var IMAGE_LIST_ADD = exports.IMAGE_LIST_ADD = 'IMAGE_LIST_ADD';
	var IMAGE_LIST_APPEND = exports.IMAGE_LIST_APPEND = 'IMAGE_LIST_APPEND';
	var IMAGE_LIST_FETCHING = exports.IMAGE_LIST_FETCHING = 'IMAGE_LIST_FETCHING';
	var IMAGE_LIST_FETCHED = exports.IMAGE_LIST_FETCHED = 'IMAGE_LIST_FETCHED';
	var IMAGE_LIST_FETCH_CANCELLED = exports.IMAGE_LIST_FETCH_CANCELLED = 'IMAGE_LIST_FETCH_CANCELLED';
	var IMAGE_LIST_LIMIT_REACHED = exports.IMAGE_LIST_LIMIT_REACHED = 'IMAGE_LIST_LIMIT_REACHED';
	var IMAGE_LIST_RESET = exports.IMAGE_LIST_RESET = 'IMAGE_LIST_RESET';
	
	var CROP_IMAGE_LOADING = exports.CROP_IMAGE_LOADING = 'CROP_IMAGE_LOADING';
	var CROP_IMAGE_LOADED = exports.CROP_IMAGE_LOADED = 'CROP_IMAGE_LOADED';
	var CROP_IMAGE_LOAD_CANCELLED = exports.CROP_IMAGE_LOAD_CANCELLED = 'CROP_IMAGE_LOAD_CANCELLED';
	var CROP_IMAGE_ADD_NEW_CROP = exports.CROP_IMAGE_ADD_NEW_CROP = 'CROP_IMAGE_ADD_NEW_CROP';
	var CROP_IMAGE_RESET_CROPS = exports.CROP_IMAGE_RESET_CROPS = 'CROP_IMAGE_RESET_CROPS';
	var CROP_IMAGE_START_UPLOADING = exports.CROP_IMAGE_START_UPLOADING = 'CROP_IMAGE_START_UPLOADING';
	var CROP_IMAGE_UPLOADED = exports.CROP_IMAGE_UPLOADED = 'CROP_IMAGE_UPLOADED';
	var CROP_IMAGE_CROPPING_CANCELLED = exports.CROP_IMAGE_CROPPING_CANCELLED = 'CROP_IMAGE_CROPPING_CANCELLED';
	var CROP_CLEAR_CROPS = exports.CROP_CLEAR_CROPS = 'CROP_CLEAR_CROPS';
	
	var GROUP_GET_INFO = exports.GROUP_GET_INFO = 'GROUP_GET_INFO';
	var GROUP_ADD_NEW = exports.GROUP_ADD_NEW = 'GROUP_ADD_NEW';
	var GROUP_ADD_MULTIPLE = exports.GROUP_ADD_MULTIPLE = 'GROUP_ADD_MULTIPLE';
	var GROUP_ADD_NEW_SIZE_TO_GROUP = exports.GROUP_ADD_NEW_SIZE_TO_GROUP = 'GROUP_ADD_NEW_SIZE_TO_GROUP';
	var GROUP_DELETE_SIZE_FROM_GROUP = exports.GROUP_DELETE_SIZE_FROM_GROUP = 'GROUP_DELETE_SIZE_FROM_GROUP';
	
	var SEARCH_START = exports.SEARCH_START = 'SEARCH_START';
	var SEARCH_END = exports.SEARCH_END = 'SEARCH_END';
	var SEARCH_CANCELLED = exports.SEARCH_CANCELLED = 'SEARCH_CANCELLED';
	var SEARCH_RESET = exports.SEARCH_RESET = 'SEARCH_RESET';
	
	var IMAGE_FILE_RESET = exports.IMAGE_FILE_RESET = 'IMAGE_FILE_RESET';
	var IMAGE_FILE_DATA_LOADING = exports.IMAGE_FILE_DATA_LOADING = 'IMAGE_FILE_DATA_LOADING';
	var IMAGE_FILE_DATA_LOADED = exports.IMAGE_FILE_DATA_LOADED = 'IMAGE_FILE_DATA_LOADED';
	var IMAGE_FILE_DATA_LOAD_FAILED = exports.IMAGE_FILE_DATA_LOAD_FAILED = 'IMAGE_FILE_DATA_LOAD_FAILED';
	var IMAGE_FILE_SAVING = exports.IMAGE_FILE_SAVING = 'IMAGE_FILE_SAVING';
	var IMAGE_FILE_SAVED = exports.IMAGE_FILE_SAVED = 'IMAGE_FILE_SAVED';
	var IMAGE_FILE_SAVE_FAILED = exports.IMAGE_FILE_SAVE_FAILED = 'IMAGE_FILE_SAVE_FAILED';
	var IMAGE_FILE_CROPS_LOADING = exports.IMAGE_FILE_CROPS_LOADING = 'IMAGE_FILE_CROPS_LOADING';
	var IMAGE_FILE_CROPS_LOADED = exports.IMAGE_FILE_CROPS_LOADED = 'IMAGE_FILE_CROPS_LOADED';
	var IMAGE_FILE_CROPS_LOAD_FAILED = exports.IMAGE_FILE_CROPS_LOAD_FAILED = 'IMAGE_FILE_CROPS_LOAD_FAILED';
	var IMAGE_FILE_TOGGLE_EDITABLE = exports.IMAGE_FILE_TOGGLE_EDITABLE = 'IMAGE_FILE_TOGGLE_EDITABLE';
	var IMAGE_FILE_ADD_KEYWORD = exports.IMAGE_FILE_ADD_KEYWORD = 'IMAGE_FILE_ADD_KEYWORD';
	var IMAGE_FILE_REMOVE_KEYWORD = exports.IMAGE_FILE_REMOVE_KEYWORD = 'IMAGE_FILE_REMOVE_KEYWORD';
	var IMAGE_FILE_UPDATE_FIELD = exports.IMAGE_FILE_UPDATE_FIELD = 'IMAGE_FILE_UPDATE_FIELD';
	
	var IMAGE_DELETE = exports.IMAGE_DELETE = 'IMAGE_DELETE';

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	var _filekeywords = __webpack_require__(274);
	
	var _filekeywords2 = _interopRequireDefault(_filekeywords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIAL_STATE = {
		keywords: [],
		caption: '',
		exif_caption: '',
		description: '',
		credit: '',
		credit_link: '',
		meta: {},
		added: false,
		suggested: [],
		metaLoaded: false,
		metaError: false,
		metaShow: false,
		uploaded: false,
		uploading: false,
		suggestedKeywords: [],
		errors: {
			keywords: false,
			credit: false,
			exif_caption: false,
			caption: false
		},
		suggestedImages: [],
		fetchingSuggested: false,
		fetchedSuggested: false,
		fetchSuggestedError: false,
		name: 'tmp.jpg',
		uploadEnabled: true,
		showModal: false,
		file: {},
		imagePath: ''
	};
	
	var fileselector = function fileselector() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actiontypes.FILES_DROPPED:
				var file = action.files[0];
				return Object.assign({}, state, {
					keywords: [],
					exif_caption: '',
					caption: '',
					description: '',
					credit: '',
					credit_link: '',
					imagePath: '',
					added: true,
					suggested: action.suggested || [],
					suggestedKeywords: action.keywords || [],
					suggestedImages: [],
					meta: {},
					errors: {
						keywords: false,
						credit: false,
						exif_caption: false,
						caption: false
					},
					name: file.name,
					showModal: false,
					file: file
				});
	
			case _actiontypes.FILES_CLEAR_ONE:
				return INITIAL_STATE;
	
			case _actiontypes.FILES_CLEAR:
				return INITIAL_STATE;
	
			case _actiontypes.FILES_ENABLE_UPLOAD:
				return Object.assign({}, state, {
					uploadEnabled: true
				});
	
			case _actiontypes.FILES_DISABLE_UPLOAD:
				return Object.assign({}, state, {
					uploadEnabled: false
				});
	
			case _actiontypes.FILES_UPLOAD_STARTED:
				return Object.assign({}, state, { uploading: true });
	
			case _actiontypes.FILES_UPLOAD_CANCELLED:
				var modData = {
					uploading: false,
					uploaded: false
				};
				if (action.errors) {
					modData.errors = Object.assign({
						keywords: false,
						exif_caption: false,
						caption: false,
						credit: false
					}, action.errors);
				}
				return Object.assign({}, state, modData);
	
			case _actiontypes.FILES_UPLOAD_COMPLETED:
				return Object.assign({}, state, {
					uploading: false,
					uploaded: true,
					file: action.file,
					errors: {}
				});
	
			case _actiontypes.FILES_SAVE_TEMP_PATH:
				if (action.imagePath && action.imagePath !== '') {
					return Object.assign({}, state, {
						imagePath: action.imagePath
					});
				}
				return state;
	
			case _actiontypes.FILES_ADD_KEYWORD:
			case _actiontypes.FILES_REMOVE_KEYWORD:
				return Object.assign({}, state, {
					keywords: (0, _filekeywords2.default)(state.keywords, action)
				});
	
			case _actiontypes.FILES_UPDATE_FIELD:
				return Object.assign({}, state, _defineProperty({}, action.name, action.value));
	
			case _actiontypes.FILES_META_LOADED:
				return Object.assign({}, state, {
					metaLoaded: true,
					metaError: false,
					meta: JSON.parse(JSON.stringify(action.data))
				});
	
			case _actiontypes.FILES_META_ERROR:
				return Object.assign({}, state, {
					metaLoaded: false,
					metaError: true,
					meta: {}
				});
	
			case _actiontypes.FILES_META_SHOW:
				if (!state.metaLoaded) {
					return state;
				}
				return Object.assign({}, state, {
					metaShow: true
				});
	
			case _actiontypes.FILES_META_HIDE:
				if (!state.metaLoaded) {
					return state;
				}
				return Object.assign({}, state, {
					metaShow: false
				});
	
			case _actiontypes.FILES_SUGGESTION_SHOW:
				if (state.suggestedKeywords.length < 1 || state.showSuggestedKeywords == true) {
					return state;
				}
				return Object.assign({}, state, {
					showSuggestedKeywords: true
				});
	
			case _actiontypes.FILES_SUGGESTION_HIDE:
				if (state.suggestedKeywords.length < 1 || state.showSuggestedKeywords == false) {
					return state;
				}
				return Object.assign({}, state, {
					showSuggestedKeywords: false
				});
	
			case _actiontypes.FILES_META_MERGE:
				if (action.data.keywords) {
					action.data.keywords = (0, _filekeywords2.default)(state.keywords, {
						type: _actiontypes.FILES_ADD_KEYWORD,
						keywords: action.data.keywords
					});
				}
				if (state.imagePath && state.imagePath === '' && action.data.filename) {
					action.data.imagePath = action.filename;
					delete action.data.filename;
				}
				var res = Object.assign({}, state, action.data);
				return res;
	
			case _actiontypes.FILES_FETCHED_IMAGE_SUGGESTIONS:
				return Object.assign({}, state, {
					suggestedImages: action.images,
					fetchedSuggested: true,
					fetchingSuggested: false,
					fetchSuggestedError: false,
					imagePath: action.imagePath || '',
					showModal: true
				});
	
			case _actiontypes.FILES_FETCHING_IMAGE_SUGGESTIONS:
				return Object.assign({}, state, {
					fetchedSuggested: false,
					fetchingSuggested: true,
					fetchSuggestedError: false,
					showModal: false
				});
	
			case _actiontypes.FILES_FETCH_ERROR_IMAGE_SUGGESTIONS:
				return Object.assign({}, state, {
					suggestedImages: [],
					fetchedSuggested: false,
					fetchingSuggested: false,
					fetchSuggestedError: true,
					showModal: false
				});
			case _actiontypes.FILES_HIDE_IMAGE_SUGGESTION_MODAL:
				return Object.assign({}, state, {
					showModal: false
				});
			default:
				return state;
		}
	};
	
	exports.default = fileselector;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = keywords;
	
	var _actiontypes = __webpack_require__(272);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function keywords() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
		var action = arguments[1];
	
		var _ret = function () {
			switch (action.type) {
				case _actiontypes.FILES_ADD_KEYWORD:
					var filteredKeys = [];
					action.keywords.forEach(function (key) {
						var tmpKey = key.trim().toLowerCase();
						if (tmpKey.length > 2 && state.indexOf(tmpKey) < 0) {
							filteredKeys.push(tmpKey);
						}
					});
					var ret = [].concat(_toConsumableArray(state), filteredKeys);
					return {
						v: ret
					};
				case _actiontypes.FILES_REMOVE_KEYWORD:
					return {
						v: state.filter(function (keyword) {
							return keyword !== action.keyword.trim().toLowerCase();
						})
					};
				default:
					return {
						v: state
					};
			}
		}();
	
		if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		;
	}

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	var INITIAL_STATE = [];
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actiontypes.GROUP_ADD_NEW:
	      return state.concat([{
	        id: action.id,
	        name: action.name,
	        sizes: action.sizes || []
	      }]);
	    case _actiontypes.GROUP_ADD_MULTIPLE:
	      return action.groups.map(function (group, index) {
	        return {
	          id: group.id,
	          name: group.name,
	          sizes: group.sizes || []
	        };
	      });
	    case _actiontypes.GROUP_ADD_NEW_SIZE_TO_GROUP:
	      return state.map(function (group) {
	        if (action.groupId !== group.id) {
	          return group;
	        }
	        return Object.assign({}, group, {
	          sizes: group.sizes.concat([{
	            id: action.id,
	            // userId: action.user_id,
	            name: action.name,
	            width: action.width,
	            height: action.height
	          }])
	        });
	      });
	    case _actiontypes.GROUP_DELETE_SIZE_FROM_GROUP:
	      return state.map(function (group) {
	        if (action.groupId !== group.id) {
	          return group;
	        }
	        return Object.assign({}, group, {
	          sizes: group.sizes.filter(function (size) {
	            return size.id !== action.id;
	          })
	        });
	      });
	    default:
	      return state;
	  }
	  return state;
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	var INITIAL_STATE = {
		images: [],
		loading: false,
		loaded: false,
		limitReached: false
	};
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actiontypes.IMAGE_LIST_APPEND:
				return Object.assign({}, state, {
					images: state.images.concat(action.images)
				});
			case _actiontypes.IMAGE_LIST_APPEND_AND_UPDATE_PAGE:
				return Object.assign({}, state, {
					images: state.images.concat(action.images)
				});
			case _actiontypes.IMAGE_LIST_FETCHING:
				return Object.assign({}, state, { loading: true });
			case _actiontypes.IMAGE_LIST_FETCHED:
				return Object.assign({}, state, {
					loaded: true,
					loading: false,
					images: action.images
				});
			case _actiontypes.IMAGE_LIST_FETCH_CANCELLED:
				return Object.assign({}, state, { loaded: false, loading: false });
			case _actiontypes.IMAGE_LIST_LIMIT_REACHED:
				return Object.assign({}, state, { limitReached: true });
			case _actiontypes.IMAGE_LIST_RESET:
				return INITIAL_STATE;
			default:
				return state;
		}
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INITIAL_STATE = {
		loading: false,
		loaded: false,
		uploading: false,
		uploaded: false,
		result: {},
		image: {},
		crops: {}
	};
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actiontypes.CROP_IMAGE_LOADING:
				return Object.assign({}, state, { loading: true, loaded: false });
			case _actiontypes.CROP_IMAGE_LOAD_CANCELLED:
				return Object.assign({}, state, { loading: false, loaded: false });
			case _actiontypes.CROP_IMAGE_LOADED:
				return Object.assign({}, state, { loading: false, loaded: true, image: action.image });
			case _actiontypes.CROP_IMAGE_ADD_NEW_CROP:
				return Object.assign({}, state, { crops: Object.assign({}, state.crops, _defineProperty({}, action.name, {
						width: action.width,
						height: action.height,
						x: action.x,
						y: action.y,
						originalWidth: action.originalWidth,
						originalHeight: action.originalHeight,
						data: action.data || ''
					})) });
			case _actiontypes.CROP_IMAGE_CROPPING_CANCELLED:
				return Object.assign({}, state, {
					uploading: false,
					uploaded: false,
					result: {}
				});
			case _actiontypes.CROP_IMAGE_START_UPLOADING:
				return Object.assign({}, state, { uploading: true });
			case _actiontypes.CROP_CLEAR_CROPS:
				return Object.assign({}, state, { crops: {} });
			case _actiontypes.CROP_IMAGE_UPLOADED:
				return Object.assign({}, state, {
					uploaded: true,
					uploading: false,
					result: action.data
				});
			case _actiontypes.CROP_IMAGE_RESET_CROPS:
				return INITIAL_STATE;
			default:
				return state;
		}
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	var INITIAL_STATE = {
	  loading: false,
	  loaded: false,
	  images: [],
	  page: 1,
	  currentPage: 1,
	  totalPage: 1
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actiontypes.SEARCH_START:
	      return Object.assign({}, state, {
	        loading: true,
	        loaded: false
	      });
	    case _actiontypes.SEARCH_END:
	      return Object.assign({}, state, {
	        loading: false,
	        loaded: true,
	        images: action.data.result,
	        currentPage: action.data.current_page,
	        totalPage: action.data.total_pages
	      });
	    case _actiontypes.SEARCH_CANCELLED:
	      return Object.assign({}, state, {
	        loaded: false,
	        loading: false
	      });
	    case _actiontypes.SEARCH_RESET:
	      return Object.assign({}, state, {
	        images: []
	      });
	  }
	  return state;
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actiontypes = __webpack_require__(272);
	
	var _config = __webpack_require__(280);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_STATE = {
	  loggedIn: false,
	  user: null,
	  loginURL: _config2.default.AUTH_SERVER,
	  checking: false,
	  checked: false
	};
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actiontypes.USER_CHECK_LOGIN:
	      return Object.assign({}, state, {
	        checking: true,
	        checked: false
	      });
	    case _actiontypes.USER_LOGGED_IN:
	      return Object.assign({}, state, {
	        loggedIn: true,
	        user: action.data,
	        checked: true,
	        checking: false
	      });
	    case _actiontypes.USER_NOT_LOGGED_IN:
	      return Object.assign({}, INITIAL_STATE, {
	        url: action.url || _config2.default.BASE_PATH + '/auth/login',
	        checked: true,
	        checking: false,
	        loggedIn: false
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getEnvironment = function getEnvironment() {
		switch (("production")) {
			case 'development':
				return 'dev';
			case 'production':
				return 'prod';
			default:
				return 'default';
		}
	};
	
	var getPublication = function getPublication(host) {
		var regex = /([a-zA-Z]+).*/;
		var match = regex.exec(host);
		switch (match[1]) {
			case 'st':
				return 'satyagrah';
			case 'hg':
				return 'homegrown';
			case 'test':
				return 'test';
			default:
				return 'scroll';
		}
	};
	
	var getConfig = exports.getConfig = function getConfig(host) {
		var publication = getPublication(host);
		var environment = getEnvironment();
		var config = __webpack_require__(281)("./" + publication + '/config.' + environment + '.js');
		return config;
	};
	
	var config = null;
	if (!config && typeof document !== "undefined") {
		config = getConfig(document.location.host);
	}
	
	exports.default = config;
	// export default config = () => {
	//	if (document.location.host) {
	//		return getConfig(document.location.host);
	//	}
	//};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./homegrown/config.default.js": 282,
		"./homegrown/config.dev.js": 283,
		"./homegrown/config.prod.js": 284,
		"./satyagrah/config.default.js": 282,
		"./satyagrah/config.dev.js": 285,
		"./satyagrah/config.prod.js": 286,
		"./scroll/config.default.js": 282,
		"./scroll/config.dev.js": 287,
		"./scroll/config.prod.js": 288,
		"./test/config.default.js": 282,
		"./test/config.dev.js": 289,
		"./test/config.prod.js": 290
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 281;


/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'http://api.server.com';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'ga-tracking-code';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://auth.server.com';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__s';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = 'localhost';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'http://localhost:8093';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://hg-cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__sh';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = 'localhost';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'https://hg-imagebank.scroll.team';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'https://hg-cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__hg';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = '.scroll.team';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'http://localhost:8092';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://st-cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__sa';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = 'localhost';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 286 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'https://st-imagebank.scroll.team';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://st-cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__st';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = '.scroll.team';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'http://localhost:8091';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__s';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = 'localhost';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'https://imagebank.scroll.team';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://cms.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__s';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = '.scroll.team';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 289 */
287,
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthURL = getAuthURL;
	var APP_NAME = exports.APP_NAME = 'ImageBank';
	var API_SERVER = exports.API_SERVER = 'http://test-imagebank.scroll.team';
	var API_PATH = exports.API_PATH = '/api/';
	var API_VERSION = exports.API_VERSION = '1.0';
	var GA_TRACKING_CODE = exports.GA_TRACKING_CODE = 'UA-asdasdasd-1';
	
	var AUTH_SERVER = exports.AUTH_SERVER = 'http://cms-dev.scroll.team';
	var AUTH_API_VERSION = exports.AUTH_API_VERSION = '1.0';
	
	var AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;
	
	function getAuthURL(url) {
	  return AUTH_API_BASE + url;
	}
	
	var Credential = exports.Credential = 'same-origin';
	var LoginURL = exports.LoginURL = getAuthURL('/auth/login');
	var LogoutURL = exports.LogoutURL = getAuthURL('/auth/logout');
	var SESSION_COOKIE_NAME = exports.SESSION_COOKIE_NAME = '__s';
	var USERINFO_COOKIE_NAME = exports.USERINFO_COOKIE_NAME = 'userinfo';
	var SESSION_COOKIE_DOMAIN = exports.SESSION_COOKIE_DOMAIN = '.scroll.team';
	
	var BASE_PATH = exports.BASE_PATH = API_SERVER + API_PATH + API_VERSION;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.keywords = keywords;
	
	var _actiontypes = __webpack_require__(272);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var INITIAL_STATE = {
	  image: {},
	  editable: false,
	  loading: false,
	  loaded: false,
	  crops: [],
	  cropLoading: false,
	  cropLoaded: false,
	  updating: false,
	  updated: false,
	  updateData: {}
	};
	
	function keywords() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	  var action = arguments[1];
	
	  var _ret = function () {
	    switch (action.type) {
	      case _actiontypes.IMAGE_FILE_ADD_KEYWORD:
	        var filteredKeys = [];
	        action.keywords.forEach(function (key) {
	          var tmpKey = key.trim().toLowerCase();
	          if (tmpKey.length > 2 && state.indexOf(tmpKey) < 0) {
	            filteredKeys.push(tmpKey);
	          }
	        });
	        var ret = [].concat(_toConsumableArray(state), filteredKeys);
	        return {
	          v: ret
	        };
	      case _actiontypes.IMAGE_FILE_REMOVE_KEYWORD:
	        return {
	          v: state.filter(function (keyword) {
	            return keyword !== action.keyword.trim().toLowerCase();
	          })
	        };
	      default:
	        return {
	          v: state
	        };
	    }
	  }();
	
	  if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  ;
	}
	
	exports.default = function () {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? INITIAL_STATE : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actiontypes.IMAGE_FILE_DATA_LOADING:
	      return Object.assign({}, state, {
	        loading: true
	      });
	    case _actiontypes.IMAGE_FILE_DATA_LOADED:
	      return Object.assign({}, state, {
	        loading: false,
	        loaded: true,
	        image: action.data
	      });
	    case _actiontypes.IMAGE_FILE_RESET:
	    case _actiontypes.IMAGE_FILE_DATA_LOAD_FAILED:
	      return INITIAL_STATE;
	    case _actiontypes.IMAGE_FILE_SAVING:
	      return Object.assign({}, state, {
	        updating: true
	      });
	    case _actiontypes.IMAGE_FILE_SAVED:
	      return Object.assign({}, state, {
	        updating: false,
	        updated: true,
	        loading: false,
	        loaded: true,
	        editable: false,
	        updateData: {},
	        image: Object.assign({}, state.image, action.data)
	      });
	    case _actiontypes.IMAGE_FILE_SAVE_FAILED:
	      return Object.assign({}, state, {
	        updating: false,
	        updated: false
	      });
	    case _actiontypes.IMAGE_FILE_CROPS_LOADING:
	      return Object.assign({}, state, {
	        cropLoading: true
	      });
	    case _actiontypes.IMAGE_FILE_CROPS_LOADED:
	      return Object.assign({}, state, {
	        cropLoading: false,
	        cropLoaded: true,
	        crops: action.data
	      });
	    case _actiontypes.IMAGE_FILE_CROPS_LOAD_FAILED:
	      return Object.assign({}, state, {
	        cropLoading: false,
	        cropLoaded: false,
	        crops: []
	      });
	    case _actiontypes.IMAGE_FILE_TOGGLE_EDITABLE:
	      return Object.assign({}, state, {
	        editable: action.data,
	        updateData: action.data === true ? Object.assign({}, state.image) : {}
	      });
	    case _actiontypes.IMAGE_FILE_ADD_KEYWORD:
	    case _actiontypes.IMAGE_FILE_REMOVE_KEYWORD:
	      return Object.assign({}, state, {
	        updateData: Object.assign({}, state.updateData, {
	          keywords: keywords(state.updateData.keywords, action)
	        })
	      });
	    case _actiontypes.IMAGE_FILE_UPDATE_FIELD:
	      return Object.assign({}, state, {
	        updateData: Object.assign({}, state.updateData, _defineProperty({}, action.name, action.value))
	      });
	    default:
	      return INITIAL_STATE;
	  }
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(218);
	
	var _reactGa = __webpack_require__(261);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _app = __webpack_require__(293);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logPageView = function logPageView() {
	    _reactGa2.default.pageview(window.location.pathname + window.location.search);
	};
	
	exports.default = function (_ref) {
	    var history = _ref.history;
	    return _react2.default.createElement(
	        _reactRouter.Router,
	        { history: history, onUpdate: logPageView },
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/', component: _app2.default },
	            _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(1, function (require) {
	                        cb(null, __webpack_require__(331).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'me', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(1/* duplicate */, function (require) {
	                        cb(null, __webpack_require__(331).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'upload', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(2, function (require) {
	                        cb(null, __webpack_require__(471).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'search', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(3, function (require) {
	                        cb(null, __webpack_require__(486).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'image/:image', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(4, function (require) {
	                        cb(null, __webpack_require__(488).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'image/:image/crop', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(5, function (require) {
	                        cb(null, __webpack_require__(495).default);
	                    });
	                } }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'sizes', getComponent: function getComponent(location, cb) {
	                    __webpack_require__.e/* nsure */(6, function (require) {
	                        cb(null, __webpack_require__(507).default);
	                    });
	                } })
	        )
	    );
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.App = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(209);
	
	var _reactDocumentTitle = __webpack_require__(294);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _header = __webpack_require__(298);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _panel = __webpack_require__(317);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	var _user = __webpack_require__(329);
	
	var _window = __webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const cropRegex = /\/image\/[\d+]{1,}\/crop.*/g;
	
	var App = exports.App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this, props));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('message', this.receiveMessage);
	      this.props.getUser();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.receiveMessage);
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage(event) {
	      var img = (0, _window.getGlobalImage)();
	      if (img === null) {
	        return;
	      } else {
	        event.source.postMessage(JSON.stringify(img), event.origin);
	        window.close();
	      }
	    }
	  }, {
	    key: 'receiveMessage',
	    value: function receiveMessage(event) {
	      if (event.data === '--GET--') {
	        var img = (0, _window.getGlobalImage)();
	        if (img === null) {
	          return;
	        } else {
	          event.source.postMessage(JSON.stringify(img), event.origin);
	          window.close();
	        }
	      }
	      if (true) {
	        try {
	          var articleData = JSON.parse(event.data);
	          if (!articleData['SETDATA']) {
	            return;
	          }
	          window.articleMeta = articleData['SETDATA'];
	        } catch (e) {
	          console.log(e);
	        }
	      }
	    }
	  }, {
	    key: 'renderLoggedOutUser',
	    value: function renderLoggedOutUser() {
	      var _props = this.props;
	      var user = _props.user;
	      var notifications = _props.notifications;
	      var checking = user.checking;
	      var checked = user.checked;
	      var loggedIn = user.loggedIn;
	
	      var message = _react2.default.createElement(
	        'a',
	        { href: user.loginURL, className: 'c-btn' },
	        'Checking Login'
	      );
	      if (checking) {
	        message = _react2.default.createElement('div', { className: 'c-loader' });
	      } else if (checked && !loggedIn) {
	        message = _react2.default.createElement(
	          'a',
	          { href: user.loginURL, className: 'c-btn' },
	          'Please Login'
	        );
	      }
	      return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: 'Please login' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container no-login' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            message
	          ),
	          _react2.default.createElement(_panel2.default, {
	            notifications: notifications })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var user = props.user;
	      var pathname = props.pathname;
	
	      if (!user.loggedIn) {
	        return this.renderLoggedOutUser();
	      }
	      return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: 'Loading...' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_header2.default, { query: props.searchQuery }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            props.children
	          ),
	          _react2.default.createElement(_panel2.default, {
	            notifications: props.notifications })
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref, ownProps) {
	  var notifications = _ref.notifications;
	  var user = _ref.user;
	
	  return {
	    user: user,
	    notifications: notifications,
	    searchQuery: ownProps.location.query || {},
	    pathname: ownProps.location.pathname
	  };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getUser: function getUser() {
	      return dispatch((0, _user.getUser)());
	    }
	  };
	};
	
	var MainApp = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);
	
	exports.default = MainApp;

/***/ },
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(299);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(218);
	
	var _grid = __webpack_require__(301);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _column = __webpack_require__(302);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _search = __webpack_require__(303);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _menu = __webpack_require__(306);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _dropdown = __webpack_require__(313);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'header',
	    { className: 'page-header' },
	    _react2.default.createElement(
	      _grid2.default,
	      null,
	      _react2.default.createElement(
	        _column2.default,
	        { width: 2 },
	        _react2.default.createElement(
	          _reactRouter.IndexLink,
	          { to: '/' },
	          'Home'
	        )
	      ),
	      _react2.default.createElement(
	        _column2.default,
	        { width: 6 },
	        _react2.default.createElement(_search2.default, { query: props.query })
	      ),
	      _react2.default.createElement(
	        _column2.default,
	        { width: 4 },
	        _react2.default.createElement(_menu2.default, { items: [{ href: '/sizes', title: 'Sizes' }]
	        })
	      )
	    )
	  );
	};
	
	/*
	<Dropdown title="Account">
	          <p>Hello</p>
	        </Dropdown>*/

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./header.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".page-header{font-size:1.4em;padding:10px 15px;border-bottom:1px solid #eee}.image-page-full .page-header{background:#252829;border-bottom:none}", ""]);
	
	// exports


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var className = 'row ';
	  if (props.className) {
	    className += props.className;
	  }
	  return _react2.default.createElement(
	    'div',
	    _extends({}, props, { className: className.trim() }),
	    props.children
	  );
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var columnClass = '';
	  if (props.small) {
	    columnClass += ' small-' + props.small;
	  }
	  if (props.medium) {
	    columnClass += ' medium-' + props.medium;
	  }
	  if (props.large) {
	    columnClass += ' large-' + props.large;
	  }
	  if (props.width) {
	    columnClass = 'large-' + props.width;
	  }
	  if (props.className) {
	    columnClass += ' ' + props.className;
	  }
	  columnClass += ' columns';
	  columnClass = columnClass.trim();
	  if (props.end) {
	    columnClass += ' end';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: columnClass },
	    props.children
	  );
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Search = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(304);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(209);
	
	var _reactRouterRedux = __webpack_require__(256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = exports.Search = function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Search).call(this, props));
	
	    _this.clear = function (e) {
	      _this.refs.query.value = "";
	      _this.refs.query.focus();
	    };
	
	    _this.clearOnEsc = function (e) {
	      if (e.which === 27) {
	        _this.clear();
	      }
	    };
	
	    _this.submitQuery = _this.submitQuery.bind(_this);
	    _this.focusInput = _this.focusInput.bind(_this);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.focusInput);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.focusInput);
	    }
	  }, {
	    key: 'focusInput',
	    value: function focusInput(e) {
	      if ((e.ctrlKey || e.metaKey) && e.keyCode === 83) {
	        e.preventDefault();
	        this.refs.query.select();
	      }
	    }
	  }, {
	    key: 'submitQuery',
	    value: function submitQuery(e) {
	      e.preventDefault();
	      console.log('submit');
	      var val = this.refs.query.value;
	      if (!val) {
	        return;
	      }
	      this.props.search(val);
	      this.refs.query.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var query = "";
	      if (this.props.query.q) {
	        query = this.props.query.q;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbar-search' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.submitQuery },
	          _react2.default.createElement(
	            'span',
	            {
	              className: 'search-clear',
	              onClick: this.clear },
	            '×'
	          ),
	          _react2.default.createElement('input', {
	            ref: 'query',
	            name: 'q',
	            type: 'text',
	            className: 'c-input',
	            onKeyDown: this.clearOnEsc,
	            defaultValue: query,
	            placeholder: 'Search for images here...',
	            autoFocus: true,
	            autoComplete: 'off' }),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'submit',
	              className: 'search-start' },
	            _react2.default.createElement('i', { className: 'fa fa-search' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    search: function search(query) {
	      dispatch((0, _reactRouterRedux.push)({
	        pathname: '/search',
	        query: {
	          q: query
	        }
	      }));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(305);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./search.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".toolbar-search{float:left;width:100%}.toolbar-search form{position:relative}.toolbar-search input[type=text]{padding-left:28px}.toolbar-search input[type=text]::-webkit-input-placeholder{text-align:center}.toolbar-search input[type=text]:-moz-placeholder{text-align:center}.search-clear{left:10px;z-index:1}.search-clear,.search-start{cursor:pointer;position:absolute;top:-2px}.search-start{right:10px;background:transparent;border:none;color:#47525d}.search-start:focus{outline:none}", ""]);
	
	// exports


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(307);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(218);
	
	var _network = __webpack_require__(309);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _config = __webpack_require__(280);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _jsCookie = __webpack_require__(312);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearAllCookie() {
	  _jsCookie2.default.remove(_config2.default.SESSION_COOKIE_NAME, {
	    path: '/',
	    domain: _config2.default.SESSION_COOKIE_DOMAIN
	  });
	  _jsCookie2.default.remove(_config2.default.USERINFO_COOKIE_NAME, {
	    path: '/',
	    domain: _config2.default.SESSION_COOKIE_DOMAIN
	  });
	  window.location.reload();
	}
	
	function logout() {
	  clearAllCookie();
	}
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'menu' },
	    props.items.map(function (item) {
	      return _react2.default.createElement(
	        'li',
	        { className: 'menu-item', key: item.href },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: item.href, activeClassName: 'link-active' },
	          item.title
	        )
	      );
	    }),
	    _react2.default.createElement(
	      'li',
	      { className: 'menu-item' },
	      _react2.default.createElement(
	        'a',
	        { onClick: logout },
	        'Logout'
	      )
	    )
	  );
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./menu.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".menu{margin:0;padding:0;list-style:none;float:right;font-size:.8em}.menu-item{display:inline-block;margin-right:20px}.menu-item a{display:block;padding:4px 0}.menu-item:last-child{margin-right:0}", ""]);
	
	// exports


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	__webpack_require__(310);
	
	var _config = __webpack_require__(280);
	
	var Config = (0, _config.getConfig)(document.location.host);
	
	var cache = {};
	
	var method = function method(url) {
		var method = arguments.length <= 1 || arguments[1] === undefined ? 'get' : arguments[1];
		var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		var contentType = 'application/json; charset=utf-8';
		if (options.form) {
			contentType = 'multipart/form-data';
		}
		if (options.form) {
			contentType = 'application/x-www-form-urlencoded';
		}
		var opt = {
			credentials: Config.Credential,
			method: method,
			headers: {}
		};
	
		if (method == 'get' || method == 'delete') {
			return fetch(Config.BASE_PATH + url, opt);
		}
		if (!options.form && options.data) {
			opt.headers['Content-Type'] = contentType;
		}
		if (options.data && method !== 'get') {
			opt.body = options.form ? options.data : JSON.stringify(options.data);
		}
	
		return fetch(Config.BASE_PATH + url, opt);
	};
	
	var checkStatus = function checkStatus(response) {
		if (response.status >= 200 && response.status < 300) {
			return response.json();
		} else {
			var error = new Error(response.statusText);
			error.response = response;
			error.status = response.status;
			throw error;
		}
	};
	
	var sendFetch = function sendFetch(ftch, success, error) {
		var context = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
		var isGet = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
		var key = arguments.length <= 5 || arguments[5] === undefined ? '' : arguments[5];
	
		// console.log(key);
		return ftch.then(checkStatus).then(function (resp) {
			if (typeof success === 'function') {
				if (isGet && key !== '') {
					cache[key] = resp;
				}
				success.call(context, resp);
			}
		}).catch(function (err) {
			if (err.response) {
				err.response.json().then(function (data) {
					if (typeof error === 'function') {
						error.call(context, {
							data: data,
							status: err.response.status
						});
					}
				});
			}
		});
	};
	
	var Fetch = {
		get: function get(path) {
			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var success = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
			var error = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
			var context = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
			var key = path;
			if (options.data) {
				key += '?';
				Object.keys(options.data).forEach(function (param) {
					key += param + '=' + options.data[param] + '&';
				});
				key = key.slice(0, -1);
				// key += JSON.stringify(options.data);
			}
			// console.log(key);
			if (cache.hasOwnProperty(key)) {
				// console.info('cache hit for ' + key);
				if (typeof success === 'function') {
					success.call(context, cache[key]);
					return;
				}
			} else {
				// console.log('cache miss for ' + key);
			}
			var ftch = method(key, 'get', options);
			sendFetch(ftch, success, error, context, true, key);
		},
		post: function post(path) {
			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var success = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
			var error = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
			var context = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
			var ftch = method(path, 'post', options);
			sendFetch(ftch, success, error, context);
		},
		del: function del(path) {
			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var success = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
			var error = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
			var context = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
			var ftch = method(path, 'delete', options);
			sendFetch(ftch, success, error, context);
		},
		put: function put(path) {
			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var success = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
			var error = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
			var context = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
			var ftch = method(path, 'put', options);
			sendFetch(ftch, success, error, context);
		},
		patch: function patch(path) {
			var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var success = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
			var error = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
			var context = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
	
			var ftch = method(path, 'patch', options);
			sendFetch(ftch, success, error, context);
		},
		clear: function clear(key) {
			if (typeof key === 'undefined' || !cache[key]) {
				cache = {};
			} else {
				Object.keys(cache).forEach(function (oldKey) {
					if (oldKey.indexOf(key) == 0) {
						delete cache[oldKey];
					}
				});
			}
		}
	};
	
	exports.default = Fetch;
	
	
	window.Fetch = Fetch;

/***/ },
/* 310 */,
/* 311 */,
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	__webpack_require__(307);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _card = __webpack_require__(314);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
		return _react2.default.createElement(
			'ul',
			{ className: 'menu' },
			_react2.default.createElement(
				'li',
				{ className: 'menu-item' },
				_react2.default.createElement(
					'a',
					{ href: '#' },
					props.title
				)
			),
			_react2.default.createElement(
				'li',
				{ className: 'menu-item' },
				_react2.default.createElement(
					_card2.default,
					{ arrow: 'ne' },
					props.children
				)
			)
		);
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(315);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  // let className = 'c-card';
	  var className = 'c-card';
	  if (props.arrow) {
	    className = 'c-card c-card--arrow c-card--arrow-' + props.arrow;
	  }
	  if (props.className) {
	    className += ' ' + props.className;
	  }
	  return _react2.default.createElement(
	    'div',
	    _extends({}, props, { className: className.trim() }),
	    props.children
	  );
	};

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./card.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./card.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".banner-card{display:block;width:100%;padding:0;box-sizing:border-box;border-radius:2px;box-shadow:0 1px 4px rgba(0,0,0,.04);border:1px solid rgba(0,0,0,.09);background-color:#fff;background-clip:padding-box;margin-bottom:25px}.banner-card img{width:100%}.banner-card p{margin:0;line-height:1.4em}.banner-card footer{padding:10px;word-break:break-word;margin-top:-8px}.banner-card.wrap-image{max-width:100%;width:auto}.banner-card.wrap-image img{max-height:300px;width:auto;max-width:100%}.banner-card.banner-error{box-shadow:0 1px 4px rgba(152,0,0,.04);border-color:rgba(255,0,0,.38);animation:card-shake 1s cubic-bezier(.36,.07,.19,.97) 3}.banner-card.banner-success{position:relative;box-shadow:0 1px 4px rgba(27,117,55,.19);border-color:rgba(2,156,35,.38)}.banner-card.banner-success:before{position:absolute;top:0;right:0;width:20px;height:20px}@keyframes card-shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}", ""]);
	
	// exports


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	__webpack_require__(318);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(320);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _notification = __webpack_require__(327);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
		return _react2.default.createElement(
			_reactAddonsCssTransitionGroup2.default,
			{ component: 'div', className: 'notification-panel', transitionName: 'list-item-anim', transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
			props.notifications.map(function (notif) {
				return _react2.default.createElement(_notification2.default, { key: notif.id, data: notif });
			})
		);
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./notification.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/index.js!./notification.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".notification-panel{position:fixed;top:20px;right:20px;max-width:600px;z-index:3}.notification-panel .notification{color:#fff;width:340px;background-color:#323232;border-radius:4px;margin:0 auto 10px;padding:8px 10px}.notification-panel .notification.notification-error{background-color:#e50000}.notification-panel .notification.notification-primary{background-color:#007ee5}.notification-panel .notification:last-child{margin-bottom:0}.notification-panel .notification-close{float:right;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(321);

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(35);
	
	var React = __webpack_require__(34);
	
	var ReactTransitionGroup = __webpack_require__(322);
	var ReactCSSTransitionGroupChild = __webpack_require__(324);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(35);
	
	var React = __webpack_require__(34);
	var ReactTransitionChildMapping = __webpack_require__(323);
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * A basis for animatins. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = _assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	    return React.createElement(this.props.component, this.props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(155);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children) {
	    if (!children) {
	      return children;
	    }
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(34);
	var ReactDOM = __webpack_require__(67);
	
	var CSSCore = __webpack_require__(325);
	var ReactTransitionEvents = __webpack_require__(326);
	
	var onlyChild = __webpack_require__(65);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClass: function (className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function () {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(CSSCore.addClass.bind(CSSCore, ReactDOM.findDOMNode(this)));
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(38);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var getVendorPrefixedEventName = __webpack_require__(136);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Notification = undefined;
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(209);
	
	var _notification = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Notification = exports.Notification = function Notification(_ref) {
		var data = _ref.data;
		var _onClick = _ref.onClick;
	
		var extraClass = ' notification-';
		if (data.type) {
			extraClass += data.type;
		} else {
			extraClass += 'primary';
		}
		return _react2.default.createElement(
			'div',
			{ className: "notification" + extraClass },
			_react2.default.createElement(
				'span',
				{ className: 'notification-close', onClick: function onClick(e) {
						_onClick(data.id);
					} },
				'×'
			),
			data.data
		);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			onClick: function onClick(id) {
				dispatch((0, _notification.removeNotification)(id));
			}
		};
	};
	
	var NotificationContainer = (0, _reactRedux.connect)(function (state) {
		return {};
	}, mapDispatchToProps)(Notification);
	
	exports.default = NotificationContainer;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showNotificationWithTimeout = exports.removeNotification = exports.addNotification = undefined;
	
	var _actiontypes = __webpack_require__(272);
	
	var _notification = __webpack_require__(271);
	
	var addNotification = exports.addNotification = function addNotification(id, data) {
	  var notifType = arguments.length <= 2 || arguments[2] === undefined ? 'primary' : arguments[2];
	  return {
	    type: _actiontypes.NOTIFICATION_ADD,
	    id: id,
	    data: data,
	    notifType: notifType
	  };
	};
	
	var removeNotification = exports.removeNotification = function removeNotification(id) {
	  return {
	    type: _actiontypes.NOTIFICATION_REMOVE,
	    id: id
	  };
	};
	
	var showNotificationWithTimeout = exports.showNotificationWithTimeout = function showNotificationWithTimeout(text) {
	  var notifType = arguments.length <= 1 || arguments[1] === undefined ? 'primary' : arguments[1];
	
	  return function (dispatch) {
	    var id = (0, _notification.getNewNotifId)();
	    dispatch(addNotification(id, text, notifType));
	
	    setTimeout(function () {
	      dispatch(removeNotification(id));
	    }, 3000);
	  };
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUser = exports.checkLogin = exports.logoutUser = exports.loginUser = undefined;
	
	var _reactGa = __webpack_require__(261);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _actiontypes = __webpack_require__(272);
	
	var _jsCookie = __webpack_require__(312);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _config = __webpack_require__(280);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _network = __webpack_require__(309);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _notification = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginUser = exports.loginUser = function loginUser(data) {
	  return {
	    type: _actiontypes.USER_LOGGED_IN,
	    data: data
	  };
	};
	
	var logoutUser = exports.logoutUser = function logoutUser(url) {
	  return {
	    type: _actiontypes.USER_NOT_LOGGED_IN,
	    url: url
	  };
	};
	
	var checkLogin = exports.checkLogin = function checkLogin() {
	  return {
	    type: _actiontypes.USER_CHECK_LOGIN
	  };
	};
	
	var getUser = exports.getUser = function getUser() {
	  return function (dispatch) {
	    dispatch(checkLogin());
	    var session_id = _jsCookie2.default.get(_config2.default.SESSION_COOKIE_NAME);
	    var data = _jsCookie2.default.get(_config2.default.USERINFO_COOKIE_NAME);
	    if (session_id && data) {
	      data = data.replace(/"/g, '');
	      var tdata = window.atob(data);
	      var userinfo = JSON.parse(tdata);
	      dispatch(loginUser(userinfo));
	    } else {
	      dispatch(logoutUser());
	      dispatch((0, _notification.showNotificationWithTimeout)('Please login to continue.'));
	    }
	  };
	};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetSuggestedKeywords = exports.getSuggestedKeywords = exports.setSuggestedKeywords = exports.setGlobalImage = exports.getGlobalImage = exports.globalImage = exports.loadAndSetCrop = exports.getScrollYPositon = exports.getOpener = undefined;
	
	var _reactRouterRedux = __webpack_require__(256);
	
	var _reactGa = __webpack_require__(261);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _network = __webpack_require__(309);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _notification = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var opener = null;
	if (window.opener !== null) {
	  opener = window.opener;
	}
	
	var getOpener = exports.getOpener = function getOpener() {
	  return opener;
	};
	
	var getScrollYPositon = exports.getScrollYPositon = function getScrollYPositon() {
	  var rect = document.body.getBoundingClientRect();
	  var windowHeight = window.innerHeight;
	  return rect.height - windowHeight - window.pageYOffset;
	};
	
	var loadAndSetCrop = exports.loadAndSetCrop = function loadAndSetCrop(image, dispatch) {
	  if (!getOpener()) {
	    return;
	  }
	  _network2.default.put('/images/' + image.id + '/use', {}, function (res) {
	    setGlobalImage(image, res);
	  }, function (err) {
	    if (err.status === 404) {
	      dispatch((0, _notification.showNotificationWithTimeout)('No crop exists for this image. Please create one first.', 'error'));
	      dispatch((0, _reactRouterRedux.push)({
	        pathname: '/image/' + image.id + '/crop'
	      }));
	    }
	  });
	};
	
	var globalImage = exports.globalImage = null;
	
	var getGlobalImage = exports.getGlobalImage = function getGlobalImage() {
	  return globalImage;
	};
	
	var setGlobalImage = exports.setGlobalImage = function setGlobalImage(image, crop) {
	  console.log(image, crop);
	  var gi = {};
	  gi.credit = image.credit;
	  gi.exif_caption = image.exif_caption;
	  gi.caption = image.caption;
	  gi.credit_link = image.credit_link;
	  Object.keys(crop.crops).forEach(function (key) {
	    gi[key] = crop.crops[key];
	  });
	  exports.globalImage = globalImage = gi;
	  if (opener !== null) {
	    _reactGa2.default.event({
	      category: 'Crops',
	      action: 'Crops exported to CMS'
	    });
	    window.opener.postMessage(JSON.stringify(globalImage));
	  }
	};
	
	var suggestedKeywords = [];
	var popCount = 0;
	
	var setSuggestedKeywords = exports.setSuggestedKeywords = function setSuggestedKeywords(keywords) {
	  suggestedKeywords = keywords.split(',').map(function (kw) {
	    return kw.trim();
	  });
	};
	
	var getSuggestedKeywords = exports.getSuggestedKeywords = function getSuggestedKeywords() {
	  if (popCount < 2) {
	    popCount++;
	    return suggestedKeywords;
	  }
	  var retVal = suggestedKeywords;
	  suggestedKeywords = [];
	  return retVal;
	};
	
	var resetSuggestedKeywords = exports.resetSuggestedKeywords = function resetSuggestedKeywords() {
	  suggestedKeywords = [];
	};

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.06669a48ff9c8ab05cfe.js
 **/